// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Park = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill}
      stroke={stroke}
      strokeWidth='2px'
    >
      <path d='M24,3c11.58,0,21,9.42,21,21s-9.42,21-21,21S3,35.58,3,24,12.42,3,24,3M24,2C11.85,2,2,11.85,2,24s9.85,22,22,22,22-9.85,22-22S36.15,2,24,2h0Z' />
      <path d='M30.23,19.9c0,1.99-.68,3.52-2.04,4.59-1.36,1.07-3.3,1.61-5.83,1.61h-2.31v7.73h-2.28V14.17h5.09c4.91,0,7.37,1.91,7.37,5.73ZM20.06,24.13h2.06c2.02,0,3.49-.33,4.4-.98.9-.65,1.36-1.7,1.36-3.15,0-1.3-.43-2.27-1.28-2.9-.85-.64-2.18-.95-3.98-.95h-2.55v7.98Z' />
    </svg>
  );
};
